module.exports = __webpack_public_path__ + "img/mr-bts-early-test.635aaa11.jpg";